import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08d38efe"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetProfile: require('/home/runner/work/PortfolioNuxt/PortfolioNuxt/components/widget/profile.vue').default,WidgetStack: require('/home/runner/work/PortfolioNuxt/PortfolioNuxt/components/widget/Stack.vue').default})
